/* eslint-disable no-undef */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import arLocale from 'element-ui/lib/locale/lang/ar'
import enLocale from 'element-ui/lib/locale/lang/en'
import ElementLocale from 'element-ui/lib/locale'

Vue.use(VueI18n)

const messages = require('../messages.json')

messages['en-US'] = Object.assign(messages['en-US'], enLocale)
messages.ar = Object.assign(messages.ar, arLocale)

// Create VueI18n instance with options
var i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'en-US', // set locale
  messages // set local messages
})

// element ui language configuration
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
